exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.list[data-v-4125b9ba] {\n  max-height: 60vh;\n  overflow: auto;\n}\n.list li[data-v-4125b9ba]:hover {\n    background-color: #f5f8fa;\n}\n.list .details[data-v-4125b9ba] {\n    position: relative;\n}\n.list .details .markRead[data-v-4125b9ba] {\n      display: none;\n      position: absolute;\n      right: 0;\n      top: 0;\n}\n.list .details:hover .markRead[data-v-4125b9ba] {\n    display: inline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4125b9ba","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Notifications.vue
// module id = 2419
// module chunks = 0